// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"23da5523","883":"a361c891"}[chunkId] + ".chunk.css";
};